import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSelectorProps {
  className?: string;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className = '' }) => {
  const { i18n, t } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: 'GB' },
    { code: 'fr', name: 'Français', flag: 'FR' }
  ];

  const handleLanguageChange = (languageCode: string) => {
    i18n.changeLanguage(languageCode);
  };

  return (
    <div className={`language-selector ${className}`}>
      {/* <span>
        {t('languageSelector.selectLanguage')}:
      </span> */}

      {languages.map((language) => (
        <button
          key={language.code}
          onClick={() => handleLanguageChange(language.code)}
          // onMouseEnter={(e) => {
          //   if (i18n.language !== language.code) {
          //     e.currentTarget.style.backgroundColor = '#f5f5f5';
          //   }
          // }}
          // onMouseLeave={(e) => {
          //   if (i18n.language !== language.code) {
          //     e.currentTarget.style.backgroundColor = 'white';
          //   }          
          // }}
          title={`Switch to ${language.name}`}

          //set className to "active" if the current language is the same as the button's language code
          className={`${i18n.language === language.code ? 'active' : ''}`}
        >
          <span>{language.name}</span>
        </button>
      ))
      }
    </div >
  );
};

export default LanguageSelector;
